import React, { useEffect, useState } from "react";
import { fetchCases, fetchCMUsers, patchCase } from "../../services/httpClient";
import { Button, Card, Col, Row, Spinner, Stack } from "react-bootstrap";
import SelectObject from "../ui/SelectObject";
import { Case } from "../../types/case";
import PageTitle from "../ui/PageTitle";

interface CaseAssignTabState {
  cases: Case[];
  setCases: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const CaseAssignmentTab = ({ cases, setCases, setShowToast, setToastText, setToastBody }: CaseAssignTabState) => {
  const [cmUsers, setCmUsers] = useState<any[]>([]);
  const [errMsg, setErrMsg] = useState<String>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCMUsers()
      .then((res: any) => {
        const users = res[0].data.map((i: any) => {
          return {
            id: i.id,
            key: i.id,
            name: i.firstname.length === 0 ? i.email : `${i.firstname} ${i.lastname}`,
          };
        });

        setCmUsers(users);
        setIsLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, []);

  const updatePrimaryCM = (e: any, caseId: any, secondaryCM: any) => {
    setErrMsg("");
    if (secondaryCM == e.target.value && e.target.value != 0) {
      setErrMsg("Primary Case Manager cannot be the same as Secondary Case Manager");
      return;
    }
    setIsLoading(true);
    const newCM = {
      primaryCM: String(e.target.value),
      secondaryCM: secondaryCM,
    };

    patchCase(newCM, caseId)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Case Updated");
        setToastBody("Primary Assigned");

        fetchCases().then((res: any) => {
          const c = res[0].data;
          setCases(c);
          setIsLoading(false);
        });
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const updateSecondaryCM = (e: any, caseId: any, primaryCM: any) => {
    setErrMsg("");
    if (primaryCM == e.target.value && e.target.value != 0) {
      setErrMsg("Secondary Case Manager cannot be the same as Primary Case Manager");
      return;
    }
    setIsLoading(true);
    const newCM = {
      primaryCM: primaryCM,
      secondaryCM: String(e.target.value),
    };

    patchCase(newCM, caseId)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Case Updated");
        setToastBody("Secondary Assigned");

        fetchCases().then((res: any) => {
          const c = res[0].data;
          setCases(c);
          setIsLoading(false);
        });
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return isLoading ? (
    <Button size="sm" className="spinner-button spinner-button-main">
      <Spinner animation="border" style={{ color: "#F6893D" }} />
    </Button>
  ) : (
    <>
      <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
        {errMsg}
      </p>
      <Row>
        <Col>
          <Stack gap={3}>
            <PageTitle title="Unassigned Cases" type="section" />
            {cases.length === 0 && <p className="mt-2">No Unassigned Case Records.</p>}
            {cases.map(
              (item: any, index: any) =>
                item.casestatus === "active" && (
                  <Card key={index} className="bg-light">
                    <Card.Body>
                      <Row>
                        <Col className="col-lg-6 col-md-4 col-sm-12">
                          {item.disabled_at ? (
                            <Card.Subtitle className="text-muted">{item.name}</Card.Subtitle>
                          ) : (
                            <Card.Subtitle>{item.name}</Card.Subtitle>
                          )}
                        </Col>
                        <Col className="col-lg-3 col-md-4 col-sm-6">
                          <SelectObject
                            label="Primary CM"
                            value={item?.primaryCM?.user_id}
                            options={cmUsers}
                            onUpdate={(e: any) => updatePrimaryCM(e, item.id, item?.secondaryCM?.user_id)}
                          />
                        </Col>
                        <Col className="col-lg-3 col-md-4 col-sm-6">
                          <SelectObject
                            label="Secondary CM"
                            value={item?.secondaryCM?.user_id}
                            options={cmUsers}
                            onUpdate={(e: any) => updateSecondaryCM(e, item.id, item?.primaryCM?.user_id)}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ),
            )}
          </Stack>
        </Col>
      </Row>
    </>
  );
};

export default CaseAssignmentTab;
